import { createSlice } from '@reduxjs/toolkit';

const verificationSlice = createSlice({
  name: 'verification',
  initialState: {
    email: '',
    userData: null,
    otp: ['', '', '', '', '', ''],
  },
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setOtpValue: (state, action) => {
      const { index, value } = action.payload;
      state.otp[index] = value;
    },
    clearOtp: (state) => {
      state.otp = ['', '', '', '', '', ''];
    },
  },
});

export const { setEmail, setUserData, setOtpValue, clearOtp } = verificationSlice.actions;
export default verificationSlice.reducer;